import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-capture-address',
  templateUrl: './capture-address.component.html',
  styleUrls: ['./capture-address.component.scss']
})
export class CaptureAddressComponent implements OnInit {
  @Input() rewardDetails: any;
  @Output() hide = new EventEmitter<boolean>();
  @Input() orderSize: any;
  userId: any;
  email: any;
  name: any;
  address: any;
  postal: any;
  city: any;
  phoneNumber: any;
  sizeSelected = '';
  rewardOrderSizes :any[] = [];


  constructor(private coreService: CoreService, private authService: AuthService, private toast: ToastrService,
    private translate: TranslateService, public gaService: GaService) {
    this.userId = authService.getUserId();
  }

  ngOnInit() {
    this.email = localStorage.getItem('email');
    if (this.rewardDetails.hasSizes) {
      var specificsizes  = this.orderSize.filter(x => x.rewardPK == this.rewardDetails.rowKey);
      if (typeof specificsizes !== 'undefined' && specificsizes.length > 0) {
        this.rewardOrderSizes = specificsizes[0].sizes;
      }
    }
    this.getLatestAddress();
  }

  getLatestAddress() {
    this.coreService.getLatestAddress(this.userId).then((response:any) => {
      if (response.result.latestUserAddress.fullName) {
        this.name = response.result.latestUserAddress.fullName;
        this.address = response.result.latestUserAddress.address;
        this.postal = response.result.latestUserAddress.postalCode;
        this.city = response.result.latestUserAddress.city;
        this.phoneNumber = response.result.latestUserAddress.number;
      }
    });
  }

  onSubmit(formRef:any) {
    if (this.rewardDetails.isDeliverable) {
      this.postDeliverableOrder();
    } else {
      this.postDigitalOrder();
    }
  }

  postDeliverableOrder() {
    const addressDetails = {
      FullName: this.name,
      Address: this.address,
      PostalCode: this.postal,
      City: this.city,
      Number: this.phoneNumber,
      Email: this.email,
      Size: this.sizeSelected

    };
    const body = {
      // Email: this.email,
      RewardKey: this.rewardDetails.rowKey,
      UserId: this.userId,
      IsDeliverableReward: true,
      Culture: this.translate.getDefaultLang(),
      RewardAddress: addressDetails
    };
    this.coreService.postOrderReward(body).then((response: any) => {
      this.gaService.emitEvent('deliverable_reward', 'deliverable_reward');
      this.coreService.pointsEmitter.emit(true);
      const message = this.translate.instant(response.messageKey);
      this.toast.success(message, ' ');
      this.onHide();
    }).catch((errorResponse: any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, ' ');
      this.onHide();
    });
  }

  postDigitalOrder() {
    const body = {
      Email: this.email,
      RewardKey: this.rewardDetails.rowKey,
      UserId: this.userId,
      Culture: this.translate.getDefaultLang(),
      IsDeliverableReward: false,
    };
    this.coreService.postOrderReward(body).then((response: any) => {
      this.gaService.emitEvent('digital_reward', 'digital_reward');
      this.coreService.pointsEmitter.emit(true);
      const message = this.translate.instant(response.messageKey);
      this.toast.success(message, ' ');
      this.onHide();
    }).catch((errorResponse: any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, ' ');
      this.onHide();
    });
  }

  onHide() {
    this.hide.emit();
  }

}
